

<div class="search-agency">
    <auto-complete [list]="agencyPartners" [field]="'showName'" [isEmitTextSearch]="true"
        (emitTextSearch)="searchAgency($event)" (result)="changeAgencyPartner($event)"
        [placeholder]="'Họ tên, mã CTV/TTV...'" [remaining]="remainingAgency"  [isNoAll]="true">
    </auto-complete>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M19 19L14.65 14.65M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z"
            stroke="#828282" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</div>